import React from "react";

export const Team = (props) => {
  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Meet the Team</h2>
          <p>
            At Nexagen Solutions, our team of talented Full Stack Developers
            brings passion, precision, and innovation to every line of code.
            Meet the brilliant minds powering Zip Accounts and other
            cutting-edge software solutions.
          </p>
        </div>
        <div id="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-12 col-sm-6 col-md-3 mb-4 team">
                  <div className="thumbnail h-100 d-flex flex-column align-items-center">
                    <img src={d.img} alt="..." className="team-img img-fluid" />
                    <div className="caption">
                      <h4>{d.name}</h4>
                      <p>{d.job}</p>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
